import axios from '@/libs/api.request'
import qs from 'qs'

export const getActivityList = (params) => {
  return axios.request({
    method: 'get',
    params,
    paramsSerializer: (query) => qs.stringify(query, { arrayFormat: 'repeat' }),
    url: '/activity'
  })
}

export const addActivity = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/activity'
  })
}

export const editActivity = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/activity'
  })
}

export const delActivity = (id) => {
  return axios.request({
    method: 'delete',
    url: '/activity/' + id
  })
}

export const getActivityInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/activity/' + id
  })
}

export const changeActivityStatus = (id, activityStatus) => {
  return axios.request({
    method: 'put',
    params: {
      activityStatus
    },
    url: '/activity/status/' + id
  })
}

export const getActivityConfigPage = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/activity/config/page'
  })
}

export const addActivityConfig = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/activity/config/add'
  })
}

export const editActivityConfig = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/activity/config/edit'
  })
}

export const getActivityConfigDetail = (id) => {
  return axios.request({
    method: 'get',
    params: {
      id
    },
    url: '/activity/config/detail'
  })
}

export const removeActivityConfig = (id) => {
  return axios.request({
    method: 'delete',
    params: {
      id
    },
    url: '/activity/config/remove'
  })
}

export const toggleActivityConfigStatus = (id) => {
  return axios.request({
    method: 'put',
    params: {
      id
    },
    url: '/activity/config/status'
  })
}

export const getActivityScoreRecordList = (params) => {
  return axios.request({
    method: 'get',
    params,
    paramsSerializer: (query) => qs.stringify(query, { arrayFormat: 'repeat' }),
    url: '/activity/scoreRecord'
  })
}

export const getActivityScoreRecordInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/activity/scoreRecord/' + id
  })
}

export const auditActivityScoreRecord = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/activity/scoreRecord/audit'
  })
}

export const getActivityConfig = (id) => {
  return axios.request({
    method: 'get',
    url: '/activity/linkConfig/' + id
  })
}

export const saveLinkConfig = (data, id) => {
  return axios.request({
    method: 'post',
    url: '/activity/saveLinkConfig/' + id,
    data
  })
}
